import { render, staticRenderFns } from "./QuickActionsCell.vue?vue&type=template&id=4b168e95&"
import script from "./QuickActionsCell.vue?vue&type=script&lang=js&"
export * from "./QuickActionsCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports